const TransactionSource = Object.freeze({
  Pax: 'pax',
  PayFabric: 'payfabric',
  GlobalPay: 'globalpay',
});

export default TransactionSource;
